import SuccessModal from './success_modal';
import { mapStateToProps } from '@reverbdotcom/discovery-ui';
import CartStore from '../../cart/cart_store';

function mapper() {
  const { cart } = CartStore.getState();

  return { cart };
}

export default mapStateToProps({
  mapper, stores: [CartStore],
})(SuccessModal, 'SuccessModal');



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/success_modal_container.jsx